import { Alert, Box, LinearProgress, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../../contexts/user-context/user-context';
import { OrderStats } from '../../common/home/home';
import LogoUploader from './logo-uploader/logo-uploader';
import Section from './section';
import NotificationManager from './notification-manager/notification-manager';
import axios from 'axios';
import {
  NotificationTemplate,
  OrganisationSettings,
} from '../../../interfaces/delivery-company/orders';
import { API_ENDPOINT } from '../../../configurations/global.config';
import ThemeColor from './color-theme/color-theme';
import Grid2 from '@mui/material/Unstable_Grid2';
import NotificationManagerTemplates from './notification-manager/notification-manager-templates';
import { emptyOrgSettings } from '../../../data/settings';
import { nanoid } from 'nanoid';
import WhatsappIntegrationConfig from './whatsapp-integration-config/whatsapp-integration-config';
import Branding from './branding/branding';
import TabsLayout from '../../common/tabs-layout/tabs-layout';
import ThemeAndNotifications from './theme-and-notifications';
import { PermissionGroups } from './permission-groups';
import Branches from '../branches/branches';
import Pricing from './pricing';
import LocationTracking from './location-tracking';

export interface VersionedLogo {
  logoUrl: string;
  version: number;
}

function Settings() {
  return (
    <div className="content-container">
      <Box>
        <Typography
          variant="h3"
          component="h3"
          sx={{ textAlign: 'center', mt: 3, mb: 3 }}
        >
          Settings
        </Typography>

        <TabsLayout
          source={"org-settings-layout"}
          orientation='horizontal'
          sections={[
            {
              label: "Pricing & Invoicing",
              content: <Pricing />
            },
            {
              label: "Theme & Notifications",
              content: <ThemeAndNotifications />
            },
            {
              label: "Driver Tracking",
              content: <LocationTracking />
            },
            {
              label: "Permission Groups",
              content: <PermissionGroups />,
            },
            {
              label: "Branches",
              content: <Branches />
            }
          ]}
          />
        
      </Box>   
    </div>
  );
}

export default Settings;
